import { useState } from "react";
import { useDispatch } from "react-redux";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from "Utils/constants";
import { CloseButton, Modal, Form, Stack, Row, Col } from "react-bootstrap";
import { TextButton } from "Components/Button";
import { PageInfo } from "Components/PageInformation/PageInformation";
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { submitEmail } from "./ForgotPasswordPopupAxiosFuncs";

const ForgotPasswordEmailPopup = ({
  show,
  handleClose
}) => {

  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [validationMsg, setValidationMsg] = useState({});
  const [globalErrorList, setGlobalErrorList] = useState([]);
  const [showMsg, setShowMsg] = useState("");

  const handleEmailChange = (e) => {
    let value = e.target.value;
    setValidationMsg({});

    setEmail(value);
  }

  // submit the email and recieve the email 
  const handleNext = async () => {
    setGlobalErrorList([]);
    const res = await submitEmail(email)
      .catch(function (error) {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
        return error.response;
      });
    

    if (res && res.data.status !== 1) {
      // set the field errors and global errors
      setGlobalErrorList(res.data.globalErrorMessageList);
 
      if (res.data.fieldErrors?.emailAddress) {
        let validation = {
          "emailAddress": {
            inValid: true,
            msg: res.data.fieldErrors?.emailAddress?.errorMessages
          }
        }

        setValidationMsg(validation);
      }
    }

    if (res && res.data.status === 1) {
      setShowMsg(res.data.message);
    }
  }

  // close popup and reset form 
  const cancel = () => {
    setGlobalErrorList([]);
    setValidationMsg({});
    setShowMsg("");
    handleClose();
  }

  return (
    <Modal className="modal" size="lg" backdrop="static" show={show} centered>
      <Modal.Header className="ps-5 pe-5">
        <Modal.Title>
          <div className="pb-3"><CloseButton className="closeup-popup-button" onClick={cancel} /></div>
          <h1>Forgot Password</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-4 pb-5 ps-5 pe-5">
        {showMsg ?
          <>
            <PageInfo className="mb-3" type="success" message={showMsg}></PageInfo>
            <br />
          </>
          : null}
        {globalErrorList.map((item, index) =>
          <>
            <PageInfo key={"errors_" + index} type="error" message={item}></PageInfo>
            <br />
          </>
        )}
        <p className="text-start pb-2">Enter the email address linked to your user profile to reset your password.</p>
        <Form.Group className="mb-2" as={Col} sm={8} controlId="emailAddress" style={{ textAlign: 'left', fontWeight: '600', color: "#004166" }}>
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter your email"
            onChange={handleEmailChange}
            isInvalid={validationMsg.emailAddress?.inValid}
          />
          <Form.Control.Feedback type="invalid" className="fieldErrorMsg">
            {validationMsg.emailAddress?.msg.map((item, index) =>
              <Stack key={"errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                <div>{item}</div>
              </Stack>)}
          </Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="ps-5 pe-5 pt-5">
        <Row className="mb-3">
          {showMsg ?
            <Col>
              <TextButton
                className="w-10"
                variant="normal"
                content={"Close"}
                onClick={cancel}
              >
              </TextButton>
            </Col> :
            <Col>
              <TextButton
                className="w-10"
                variant="normal"
                content={"Submit"}
                onClick={handleNext}
              >
              </TextButton>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <TextButton
                className="w-10"
                variant="outline"
                content={"Cancel"}
                onClick={cancel}
              >
              </TextButton>
            </Col>}
        </Row>
      </Modal.Footer>
    </Modal>
  )
}

export default ForgotPasswordEmailPopup;